<template>
  <div>
    <el-card class="position-absolute model-edit" :style="{ height: height, top: top }">
      <div slot="header" class="d-flex flex-row-between">
        <span class="fz-14">节点编辑树</span>
        <div class="d-flex tr">
          <el-tooltip content="导出为pr文件" :open-delay="1000" effect="light">
            <el-button
              type="success"
              :loading="showLoadProgress"
              class="iconfont icon-upload2"
              @click="uploadPrFile"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="保存修改" :open-delay="1000" effect="light">
            <el-button
              type="primary"
              class="iconfont icon-save"
              @click="saveEngineerData"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="修改节点名称" :open-delay="1000" effect="light">
            <el-button type="primary" class="iconfont icon-edit" @click="editNodeName"></el-button>
          </el-tooltip>
          <el-tooltip content="删除节点" :open-delay="1000" effect="light">
            <el-button type="danger" class="iconfont icon-close" @click="deleteNode"></el-button>
          </el-tooltip>
          <el-tooltip content="新增节点" :open-delay="1000" effect="light">
            <el-button type="primary" class="iconfont icon-yxr-zj" @click="createNode"></el-button>
          </el-tooltip>
          <span
            class="m-l-10 iconfont icon-close r cur_pointer fz-12"
            @click="closeComponent"
          ></span>
        </div>
      </div>

      <div class="height-38 p-5 m-t-5">
        <el-input
          size="small"
          placeholder="请输入要过滤的设备"
          v-model="filterTreeKeyWords"
          @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-arrow-down"
            @click="filterModelTree(currentLocationNode.item, true, filterTreeKeyWords, 0)"
            class="p-l-10 p-r-10"
          ></el-button>
          <el-button
            slot="append"
            icon="el-icon-arrow-up"
            @click="filterModelTree(currentLocationNode.item, false, filterTreeKeyWords, 0)"
            class="p-l-10 p-r-10"
          ></el-button>
        </el-input>
      </div>
      <div class="form_body" @click="menuVisible = false" v-loading="!treeShow">
        <el-tree
          draggable
          :props="defaultProps"
          :load="loadNode"
          lazy
          ref="nodeEditTree"
          id="nodeEditTree"
          @node-click="handleNodeClick"
          v-if="treeShow"
          highlight-current
          :allowDrag="allowDrag"
          :allowDrop="allowDrop"
          node-key="nodePtr"
          :default-expanded-keys="defaultExpandedKeys"
          @node-drop="handleNodeDrop"
          @node-collapse="handleNodeCollapse"
        >
          <div
            @contextmenu.prevent="
              (e) => {
                showMenus(e, node, data)
              }
            "
            class="custom-tree-node text-overflow w-100 d-flex flex-align-between"
            slot-scope="{ node, data }"
          >
            <span>{{ data.name }}</span>
          </div>
        </el-tree>
      </div>
      <div
        class="card position-fixed"
        v-if="menuVisible"
        :style="{ left: positon.X + 'px', top: positon.Y + 'px' }"
      >
        <div class="w-100 cur_pointer fz-12 m-b-5" @click="createNode">新增节点</div>
        <div class="w-100 cur_pointer fz-12 m-b-5" v-if="ableDelete" @click="deleteNode">
          删除节点
        </div>
        <div class="w-100 cur_pointer fz-12 m-b-5" @click="editNodeName">修改节点名称</div>
      </div>
      <el-dialog
        :title="isCreate ? '模型节点新增' : '模型节点编辑'"
        :visible.sync="modifyVisible"
        width="30%"
        :close-on-click-modal="false"
        :lock-scroll="true"
        :before-close="modifyDialogClose"
        :modal="false"
      >
        <div>
          <el-form ref="modifyForm" :model="modifyForm" :rules="modifyRules" label-width="80px">
            <el-form-item label="节点名称" prop="name">
              <el-input
                v-model="modifyForm.name"
                clearable
                placeholder="请输入节点名称"
                size="small"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="modifyDialogClose" size="small">取 消</el-button>
          <el-button type="primary" @click="saveNodeInfo" size="small">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import FnMixins from '@/assets/js/fnMixins'
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinModelCenter from '@/assets/js/api/modelCenter'
import { saveSceneToJson, isJSONObj } from '@/views/documentBrowse/js/engineerSceneData'
import { multipleLocations } from '../js/publicModelMays'

const PlayerProgress = () => {
  return import('../PlayerProgress')
}
export default {
  name: 'NodeEditTree',
  mixins: [FnMixins, ApiMixinModelCenter],
  components: { PlayerProgress },
  props: ['documentId', 'player', 'height', 'top', 'currentCreateNode', 'currentEditMoment'],
  data() {
    return {
      positon: {
        X: '',
        Y: '',
      },
      menuVisible: false,
      input: '',
      defaultProps: {
        label: 'name',
        children: 'zones',
      },
      count: 1,
      modifyVisible: false, // 编辑框显隐
      modifyForm: { name: '' },
      modifyRules: { name: [{ required: true, message: '请输入节点名称', trigger: 'change' }] },
      treeShow: false,
      ableDelete: false,
      currentNodeData: {},
      defaultExpandedKeys: [],
      currentLocationNode: null,
      saveStatus: false,
      filterTreeKeyWords: '',
      loadType: '',
      loadPercentage: 0,
      showLoadProgress: false,
      engineerThumbnails: '',
      engineerName: '',
      isCreate: false,
      uploadLoading: false,
      exportPath: '',
      fileTexture: '',
      exportPrName: '',
    }
  },
  watch: {
    currentCreateNode(val, oldVal) {
      this.$nextTick(() => {
        if (val !== oldVal) {
          this.treeShow = false
          setTimeout(async () => {
            this.treeShow = true
            const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(val)
            this.currentLocationNode = val
            this.expendNode(nodeInfo)
          }, 100)
        }
      })
    },
    currentEditMoment(val, oldVal) {
      this.$nextTick(() => {
        if (val !== oldVal) {
          this.treeShow = false
          setTimeout(async () => {
            this.treeShow = true
            const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(this.currentCreateNode)
            this.currentLocationNode = this.currentCreateNode
            this.expendNode(nodeInfo)
          }, 100)
        }
      })
    },
  },
  async created() {
    this.treeShow = true
  },
  computed: {
    fullToken() {
      return this.$store.getters.fullToken
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (e.button !== 2) {
        this.menuVisible = false
      }
    })
  },
  methods: {
    // 监听上传成功
    uploadFinish(file, err, ret, total) {
      console.log(file, err, ret, total)
      try {
        const result = JSON.parse(ret)
        if (result && result.code === 0 && result.data) {
          this.loadType = '上传pr文件...'
          this.showLoadProgress = true
          this.monitorProgress(result.data)
        } else {
          this.uploadLoading = false
          this.$message.warning(result.msg)
        }
      } catch (error) {
        console.log(error)
      }
      this.player.Native.File.EventUploadFinish.disconnect(this.uploadFinish)
    },
    // 上传附件结束
    async uploadTextureFinish(file, err, ret, total) {
      await this.player.Native.File.EventUploadFinish.disconnect(this.uploadTextureFinish)
      await this.player.Native.File.EventUploadProcessChanged.disconnect(this.uploadTextureProcess)
      this.showLoadProgress = false
      this.loadPercentage = 0
      try {
        const result = JSON.parse(ret)
        if (result && result.success && result.dataList && !_.isEmpty(result.dataList)) {
          this.fileTexture = result.dataList[0].path
        } else {
          this.uploadLoading = false
          this.$message.warning(result.msg)
        }
      } catch (error) {
        console.log(error)
      }
      await this.player.Native.File.EventUploadFinish.connect(this.uploadFinish)
      await this.player.Native.File.uploadFile(
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/document/modelupload`,
        { 'Content-Type': 'multipart/form-data', Authorization: `${this.fullToken}` },
        { file: `@${this.exportPath}/${this.exportPrName}.pr` }
      )
    },
    // 上传附件进度
    uploadTextureProcess(file, bytesReceived, bytesTotal) {
      if (bytesTotal > 0) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    // 合并文件
    async mergeFile() {
      const rootItem = await this.player.Native.ModelTree.getRootItems()
      // 在跟节点集合中查找我们设置的场景的跟节点
      const rootNode = _.find(rootItem, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const data = await saveSceneToJson(rootNode.nodePtr, this.player)
      const filePathList = this.getFilePath(data, [])
      this.exportPath = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/export`
      this.exportPrName = data.name
      const exportRes = await this.player.Native.NodeProxy.exportNodes(
        `${this.exportPath}/${data.name}.pr`,
        filePathList,
        true
      )
      return exportRes
    },
    // 导出为pr文件并上传到文档管理
    async uploadPrFile() {
      this.uploadLoading = true
      const exportRes = await this.mergeFile()
      if (exportRes) {
        await this.player.Native.File.EventUploadFinish.connect(this.uploadTextureFinish)
        await this.player.Native.File.EventUploadProcessChanged.connect(this.uploadTextureProcess)
        const uploadRes = await this.player.Native.File.uploadFile(
          `${currentEnv.VUE_APP_PLANT_SERVER}/file/upload_files_hdd`,
          { 'Content-Type': 'multipart/form-data', Authorization: `${this.fullToken}` },
          { file: `@${this.exportPath}/Texture.zip`, siteId: this.currentProject.id }
        )
        if (uploadRes) {
          this.loadType = '上传贴图文件...'
          this.showLoadProgress = true
        }
      }
    },
    // 获取工程信息
    async getEngineerInfo() {
      if (this.$route.query.engineerId) {
        const res = await DocumentManagementService.getDocumentEdite({
          id: this.$route.query.engineerId,
        })
        if (res && res.code === 0 && res.data) {
          this.engineerThumbnails = res.data.documentBaseInfo.thumbnails
          this.engineerName = res.data.documentBaseInfo.name
        }
      }
    },
    // 获取文件路径集合
    getFilePath(data, arr = []) {
      if (data.code && data.code.filePath) {
        arr.push(data.code.filePath)
      }
      if (!_.isEmpty(data.children)) {
        for (let i = 0; i < data.children.length; i += 1) {
          this.getFilePath(data.children[i], arr)
        }
      }
      return arr
    },
    // 更新文档信息
    async updateDocument(id) {
      const documentAttr = {}
      // 获取模型类别
      const parameter = _.find(this.$store.getters.systemParams, (item) => {
        return item.parameterCode === 'docClass3DModelClass'
      })
      // 获取模型通用属性
      const templateAttr = _.find(this.$store.getters.systemParams, (item) => {
        return item.parameterCode === 'MultipleModelTemplate'
      })
      if (parameter) {
        const documentClassId = parameter.parameterValue.split(',')[0]
        const res = await DocumentManagementService.getTemplateByClassId({
          classId: documentClassId,
        })
        if (res && res.code === 0 && res.data) {
          _.assign(documentAttr, res.data)
          const classAttr = !_.isNil(templateAttr) ? templateAttr.parameterValue : ''
          if (res.data.templateAttrSetList && !_.isEmpty(res.data.templateAttrSetList)) {
            const templateAttrSetList = _.filter(res.data.templateAttrSetList, (item) => {
              return item.attributeTemplate.code === classAttr
            })
            documentAttr.templateAttrSetList = _.cloneDeep(templateAttrSetList)
            // 获取模型贴图属性对应字段
            const index = _.findIndex(documentAttr.templateAttrSetList[0].attrValueList, [
              'fieldName',
              'material',
            ])
            this.$set(
              documentAttr.templateAttrSetList[0].attrValueList[index],
              'attrValue',
              this.fileTexture
            )
          }
        }
      }
      // 先获取文档详情
      const detailRes = await DocumentManagementService.getDocumentEdite({ id })
      if (detailRes && detailRes.code === 0 && detailRes.data) {
        const params = {
          document: detailRes.data.documentBaseInfo,
          generalAttrSet: detailRes.data.generalAttrSet,
          templateAttrSetList: documentAttr.templateAttrSetList,
        }
        params.document.thumbnails = this.engineerThumbnails
        params.document.name = this.engineerName
        params.document.code = `${this.engineerName}${moment().format('YYYYMMDDHHmmss')}`
        console.log(params)
        const res = await this.apiModelCenter({
          method: 'editMultiple',
          params,
        })
        if (res && res.code === 0) {
          const fileMd5 = await this.player.Native.File.getFileMd5(
            `${this.exportPath}/${this.exportPrName}.pr`
          )
          if (fileMd5) {
            await this.player.Native.File.move(
              `${this.exportPath}/${this.exportPrName}.pr`,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${fileMd5}/${fileMd5}.pr`
            )
            await this.player.Native.File.move(
              `${this.exportPath}/Texture.zip`,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${fileMd5}/${fileMd5}.pr.texPackage`
            )
          }
          this.$message.success('上传成功')
        } else {
          this.$message.warning(res.message)
        }
      }
    },
    // 加进度条的方法
    async monitorProgress(id) {
      const res = await axios.get(
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/share/common/query_progress_bar/${id}`
      )
      if (res && res.status === 200 && !_.isEmpty(res.data) && res.data.code === 0) {
        if (res.data.data < 100 || !res.data.url) {
          // 返回文件流的时候
          this.loadPercentage = Number(res.data.data)
          setTimeout(() => {
            this.monitorProgress(id)
          }, 1500)
        } else {
          this.loadPercentage = 100
          setTimeout(async () => {
            this.showLoadProgress = false
            this.uploadLoading = false
            this.loadPercentage = 0
            await this.getEngineerInfo()
            this.updateDocument(res.data.url)
          }, 300)
        }
      } else {
        this.showLoadProgress = false
        this.uploadLoading = false
        this.loadPercentage = 0
        this.$message.warning(res.data.msg)
      }
    },
    // 收起节点
    handleNodeCollapse(data) {
      _.remove(this.defaultExpandedKeys, (item) => {
        return item === data.nodePtr
      })
    },
    // 保存模型修改
    async saveEngineerData() {
      if (this.$route.query.engineerId) {
        // 从模型树的上拿到根节点
        const rootItem = await this.player.Native.ModelTree.getRootItems()
        // 在跟节点集合中查找我们设置的场景的跟节点
        const rootNode = _.find(rootItem, (val) => {
          return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
        })

        if (rootNode) {
          const data = await saveSceneToJson(rootNode.nodePtr, this.player)
          const res = await DocumentManagementService.getSceneJsonData({
            id: this.$route.query.engineerId,
          })
          if (res && res.code === 0) {
            const params = {
              documentId: this.$route.query.engineerId,
              treeJson: JSON.stringify(data),
            }
            if (res.data && res.data.id) {
              params.id = res.data.id
            }
            const saveRes = await DocumentManagementService.saveSceneJsonData(params)
            if (saveRes && saveRes.code === 0) {
              this.$message.success('保存成功')
              this.saveStatus = true
            } else {
              this.$message.warning(res.message)
            }
          }
        }
      }
    },
    // 展开节点
    handleNodeExpand(data) {
      this.defaultExpandedKeys.push(data.nodePtr)
    },
    async filterModelTree(startItem, direction, KeyWords, type) {
      // 过滤模型树
      this.currentLocationNode = await this.player.Native.ModelTree.findItemByName(
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentLocationNode)) {
        await this.expendModelTree(this.currentLocationNode)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendModelTree(node) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.locationNode(this.currentLocationNode.nodePtr)
        })
      } else {
        const res = await this.player.Native.ModelTree.getItemInfo(node.parentItem)
        await this.expendModelTree(res)
        // 展开
        this.defaultExpandedKeys.push(res.nodePtr)
      }
    },
    // 展开节点树
    async expendNode(node) {
      if (isJSONObj(node.code) && JSON.parse(node.code).type === 'Root') {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          // 有选中激活节点时
          this.locationNode(this.currentLocationNode)
        })
      } else {
        const res = await this.player.Native.NodeProxy.getNodeInfo(node.parentPtr)
        // 展开
        this.defaultExpandedKeys.push(res.nodePtr)
        this.expendNode(res)
      }
    },
    // 定位树节点
    locationNode(id) {
      this.$nextTick(() => {
        console.log(this.$refs.nodeEditTree)
        setTimeout(() => {
          this.$refs.nodeEditTree.setCurrentKey(id)
          const node = document.getElementById('nodeEditTree')
          setTimeout(() => {
            const currentNode = document.getElementsByClassName('is-current')[0]
            console.log(currentNode)
            node.scrollTo({
              top: currentNode.offsetTop,
            })
          }, 400)
        }, 400)
      })
    },
    // 允许拖拽的节点
    allowDrag(node) {
      return node.level > 1
    },
    allowDrop(dragNode, dropNode) {
      if (dragNode.data.nodePtr !== dropNode.data.nodePtr) {
        if (!dropNode.parent.data) {
          const temp = []
          _.forEach(dropNode.parent.childrenNodes, (item) => {
            temp.push(item.data)
          })
          dropNode.parent.data = temp
        }
        return true
      }
    },
    // 拖拽结束
    async handleNodeDrop(beforeNode, afterNode) {
      console.log(beforeNode.data, afterNode.data)
      this.treeShow = false
      await this.player.Native.NodeProxy.setNodeParent(
        beforeNode.data.nodePtr,
        afterNode.data.nodePtr
      )
      this.treeShow = true
    },
    // 保存节点信息
    saveNodeInfo() {
      this.$refs.modifyForm.validate(async (valid) => {
        if (valid) {
          this.treeShow = false
          let currentNode = null
          if (this.isCreate) {
            const findNode = await this.player.Native.NodeProxy.findFirstNodeByName(
              this.currentNodeData.nodePtr,
              this.modifyForm.name
            )
            console.log(this.currentNodeData)
            if (findNode === 0 || findNode === this.currentNodeData.nodePtr) {
              currentNode = await this.player.Native.NodeProxy.createNode(
                this.currentNodeData.nodePtr,
                this.modifyForm.name
              )
              await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
                code: JSON.stringify({ type: 'userData' }),
              })
            } else {
              this.$message.warning('该节点下已存在相同名称的节点')
              this.treeShow = true
              return
            }
          } else {
            const currentParent = await this.player.Native.NodeProxy.getNodeParent(
              this.currentNodeData.nodePtr
            )
            const findNode = await this.player.Native.NodeProxy.findFirstNodeByName(
              currentParent.nodePtr,
              this.modifyForm.name
            )
            if (findNode === 0 || findNode === this.currentNodeData.nodePtr) {
              await this.player.Native.NodeProxy.setNodeInfo(this.currentNodeData.nodePtr, {
                name: this.modifyForm.name,
              })
              currentNode = this.currentNodeData.nodePtr
            } else {
              this.$message.warning('该节点下已存在相同名称的节点')
              this.treeShow = true
              return
            }
          }
          const currentNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(currentNode)
          this.currentLocationNode = currentNode
          this.treeShow = true
          this.expendNode(currentNodeInfo)
          this.modifyDialogClose()
          return true
        }
        return false
      })
    },
    // 关闭编辑框
    modifyDialogClose() {
      this.modifyForm = this.$options.data().modifyForm
      this.$refs.modifyForm.resetFields()
      this.modifyVisible = false
      this.isCreate = false
      this.$emit('modifyNodeEnd', moment().valueOf(), this.currentNodeData)
    },
    // 新增子节点
    createNode() {
      if (!this.currentNodeData.nodePtr) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      this.isCreate = true
      this.modifyVisible = true
    },
    // 删除节点
    async deleteNode() {
      if (!this.currentNodeData.nodePtr) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      if (
        this.currentNodeData.code &&
        this.isJSONObj(this.currentNodeData.code) &&
        JSON.parse(this.currentNodeData.code).type === 'Root'
      ) {
        this.$message.warning('该节点无法删除')
        return
      }
      this.treeShow = false
      const editNode = await this.player.Native.NodeEditor.node()
      if (editNode === this.currentNodeData.nodePtr) {
        await this.player.Native.NodeEditor.setNode(0)
      }
      await this.player.Native.NodeProxy.destroyNode(this.currentNodeData.nodePtr)
      this.treeShow = true
      this.currentNodeData = {}
      this.$emit('handleNodeClick', {})
      this.$emit('modifyNodeEnd', moment().valueOf(), null)
    },
    // 修改节点名称
    async editNodeName() {
      if (!this.currentNodeData.nodePtr) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(this.currentNodeData.nodePtr)
      this.currentNodeData = _.cloneDeep(nodeInfo)
      this.modifyVisible = true
      this.modifyForm.name = this.currentNodeData.name
    },
    // 右键点击弹出框
    showMenus(e, node, data) {
      this.ableDelete =
        node.level > 1 && data.code && isJSONObj(data.code) && JSON.parse(data.code).type
      console.log(e, node, data)
      this.positon.X = e.clientX
      this.positon.Y = e.clientY
      this.menuVisible = true
      this.currentNodeData = data
    },
    // 关闭弹窗
    closeComponent() {
      this.$confirm('是否保存模型节点信息？', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning',
      })
        .then(async () => {
          this.saveEngineerData()
          this.$emit('closeComponents', 'NodeEditTree')
        })
        .catch(() => {
          this.$emit('closeComponents', 'NodeEditTree')
        })
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    handleNodeClick(data) {
      multipleLocations(this.player, data, false, null)
      this.currentNodeData = data
      this.$emit('handleNodeClick', data)
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const rootRes = await this.player.Native.ModelTree.getRootItems()
        return resolve(rootRes)
      }
      const subRes = await this.player.Native.NodeProxy.getNodeChildren(node.data.nodePtr)
      return resolve(subRes)
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/select.scss';
@import '../css/index.scss';
.model-edit {
  width: 368px;
  left: 35px;
  z-index: 99;
  color: #fff !important;
  padding: 10px;
  border: none;
  background-color: rgba(46, 107, 176, 0.5) !important;
  border: none !important;
}
/deep/.el-card {
  &__body {
    padding: 0 !important;
    height: calc(100% - 30px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
.form_header_input {
  display: flex;
  width: 100%;
  span {
    margin-top: 5px;
    margin-left: 2px;
    border: 1px solid #888;
    text-align: center;
    line-height: 36px;
    width: 46px;
    height: 36px;
    background: #555;
  }
}
.form_body {
  height: calc(100% - 45px);
}
.card {
  background-color: rgba(24, 41, 72, 0.8);
  z-index: 400;
  padding: 10px 10px;
  width: 150px;
  border-radius: 3px;
  color: #ffffff;
}
/deep/ .el-loading-mask {
  position: relative;
  height: 100%;
  background-color: rgba(24, 41, 72, 0.8) !important;
}
/deep/.el-tree {
  height: 100% !important;
}

</style>
